import { createStore, applyMiddleware, combineReducers } from 'redux';
import { HYDRATE, createWrapper } from 'next-redux-wrapper';
import { composeWithDevTools } from 'redux-devtools-extension';
// import { createLogger } from 'redux-logger';
import { createEpicMiddleware } from 'redux-observable';

import updateHydrateState from '@src/router/hydrate';

import rootEpic from './epics';
import rootReducer from './reducers';

const bindMiddleware = middleware => {
	if (process.env.NODE_ENV !== 'production') {
		return composeWithDevTools(applyMiddleware(...middleware));
	}
	return applyMiddleware(...middleware);
};

const combinedReducer = combineReducers(rootReducer);

const reducer = (state, action) => {
	if (action.type === HYDRATE) {
		const nextState = updateHydrateState(state, action.payload);

		if (state.count) nextState.count = state.count; // preserve count value on client side navigation
		return nextState;
	}
	// 避免使用者 A 登出後切到登入頁、使用者 B 登入前，畫面還殘留 A 的資料
	if (action.type === 'LOGOUT_DONE') {
		const nextState = combinedReducer(undefined, action);
		if (state?.theme) nextState.theme = state.theme;
		if (state?.themeClient) nextState.themeClient = state.themeClient;
		return nextState;
	}
	return combinedReducer(state, action);
};

let clientStore = null;

const initStore = () => {
	const epicMiddleware = createEpicMiddleware();

	const store = createStore(
		reducer,
		bindMiddleware([
			epicMiddleware,
			// createLogger({ predicate: () => process.env.NODE_ENV === 'development' }),
		]),
	);

	epicMiddleware.run(rootEpic);

	if (typeof window !== 'undefined') {
		clientStore = store;
	}

	return store;
};

// 供非 React 程式（如 axios interceptor）取得目前 client 端的 Redux store。
// SSR 期間回傳 null，呼叫端需自行判斷。
export const getClientStore = () => clientStore;

export default createWrapper(initStore);
